import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PerInfoBoxInputNumberElement } from '../../../../components/custom_components/InfoBox/InfoBoxInputNumberElement'
import useCompanyRankingSettingsMutations from '../../../../graphql/company-ranking-settings/hooks/useCompanyRankingSettingsMutations'

import { CompanySettingsRankingsSettingsFormProps } from './CompanySettingsRankingsSettingsForm'
import { CompanySettingsRankingTopTagProcess } from './CompanySettingsRankingTopTagProcess'
import { useCompanySettingsRankingFormControl } from './useCompanySettingsRankingFormControl'

export const CompanySettingsRankingTopTagControl: FC<CompanySettingsRankingsSettingsFormProps> = ({
  companyId,
  country,
  settings,
  disabled,
}) => {
  const { t } = useTranslation()

  const { updateTopPercentage } = useCompanyRankingSettingsMutations(companyId, country)

  const [formValue, setFormValue] = useCompanySettingsRankingFormControl<number>(settings.topPercentage, updateTopPercentage)

  const handleChange = (val) => {
    const value = Number.parseFloat(val)
    setFormValue(!!value ? (value > 100 ? 100 : value) : 0)
  }

  return (
    <>
      <PerInfoBoxInputNumberElement
        label={t('companySettingsView.rankingTab.settings.topPercentage')}
        type="decimalPercentage"
        min={0}
        max={100}
        width="90px"
        step={0.1}
        value={formValue || 0}
        onChange={handleChange}
        disabled={disabled}
      />
      {!disabled && (
        <CompanySettingsRankingTopTagProcess
          label={t('companySettingsView.rankingTab.settings.topPerformance')}
          companyId={companyId}
          country={country}
          settings={settings}
          disabled={!settings.topPercentage || !formValue}
        />
      )}
    </>
  )
}
